export enum AssetValidationCategory {
    passesValidationNewAsset = 1,
    passesValidationModifiedAsset = 2,
    requiresReview = 3,
    duplicateRecordsWithinExistingFile = 4,
    duplicateRecordsWithinExistingAssets = 5,
    conflictsWithExistingFiles = 6,
    modifiesExistingAssets = 7
}
